import {combineReducers} from "redux";
import authReducer from "../Auth/Slice";
import ModalReducer from "../Modal/Slice";
import LoadingReducer from "../Loading/Slice";
import CompanyReducer from "../Company/Slice";
import SideMenuReducer from "../SideMenu/Slice";
import PickupReducer from "../Pickup/Slice";
import FilterReducer from "../Filter/Slice";
import ContactReducer from "../Contact/Slice";
import PaymentReducer from "../PaymentType/Slice";
import PackingReducer from "../PackingType/Slice";
import AddressReducer from "../Address/Slice";
import ZoneReducer from "../Zone/Slice";
import CityReducer from "../City/Slice";
import BillingReducer from "../Billing/Slice";
import ShipmentReducer from "../Shipments/Slice";

const RootReducer = combineReducers({
  authReducer,
  ModalReducer,
  LoadingReducer,
  CompanyReducer,
  SideMenuReducer,
  PickupReducer,
  FilterReducer,
  ContactReducer,
  PaymentReducer,
  PackingReducer,
  AddressReducer,
  CityReducer,
  ZoneReducer,
  BillingReducer,
  ShipmentReducer
});

export default RootReducer;
export type RootState = ReturnType<typeof RootReducer>;
